import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/96a404ca-4b33-45a9-aff5-73665010c728.png" 
              alt="OPEN STUDIO d.o.o." 
              className="h-12 w-auto"
            />
          </div>

          <div className="flex items-center gap-10">
            <button 
              onClick={() => scrollToSection('home')}
              className={`text-sm font-light transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-sm font-light transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('vpn-service')}
              className={`text-sm font-light transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              VPN Service
            </button>
            <button 
              onClick={() => scrollToSection('features')}
              className={`text-sm font-light transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              Features
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-light transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              Contact
            </button>
          </div>

          <button 
            onClick={() => scrollToSection('contact')}
            className="bg-gradient-to-r from-purple-600 to-purple-700 text-white px-6 py-3 rounded-full text-sm font-medium hover:shadow-lg transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            Get Started
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
